import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { DatePipe, DecimalPipe } from '@angular/common'
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, startWith, switchMap, tap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ClasePorEstado, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { PedidoVentaCabecera } from 'src/app/shared/models/pedidoVentaCabecera';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { Compania } from 'src/app/shared/models/compania';
import { AdmService } from 'src/app/shared/services/adm.service';
import { SelectorDivisionesComponent } from 'src/app/shared/components/selector-divisiones/selector-divisiones.component';
import { SelectorRegionesComponent } from 'src/app/shared/components/selector-regiones/selector-regiones.component';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { SelectorEstadoPedidosComponent } from 'src/app/shared/components/selector-estado-pedidos/selector-estado-pedidos.component';
import { BuscadorReportePedido } from 'src/app/shared/models/buscadorReportePedido';
import { ZonaVendedor } from 'src/app/shared/models/zonaVendedor';
import { ReportesService } from 'src/app/shared/services/reportes.service';
import { PedidoCabecera } from 'src/app/shared/models/pedidoCabecera';
import { SelectorTiposOrdenesComponent } from 'src/app/shared/components/selector-tipos-ordenes/selector-tipos-ordenes.component';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { Estado } from 'src/app/shared/models/estado';
import { BuscadorReportePedidoDetallado } from 'src/app/shared/models/buscadorReportePedidoDetallado';
import { Producto } from 'src/app/shared/models/producto';
import { PedidoDetallado } from 'src/app/shared/models/pedidoDetallado';
import { Division } from 'src/app/shared/models/division';
import { Region } from 'src/app/shared/models/region';

@Component({
  selector: 'app-reportes-pedidos-detallados-buscador',
  templateUrl: './reportes-pedidos-detallados-buscador.component.html'
})
export class ReportesPedidosDetalladosBuscadorComponent {

  @ViewChild(SelectorDivisionesComponent, { static: true }) selectorDivision: SelectorDivisionesComponent;
  @ViewChild(SelectorRegionesComponent, { static: true }) selectorRegion: SelectorRegionesComponent;
  @ViewChild(SelectorEstadoPedidosComponent, { static: true }) selectorEstadoPedido: SelectorEstadoPedidosComponent;
  @ViewChild(SelectorTiposOrdenesComponent, { static: true }) selectorTiposOrdenes: SelectorTiposOrdenesComponent;
  @ViewChild('matSort') matSort: MatSort;
  @ViewChild('matPaginator') matPaginator: MatPaginator;
  displayedColumns = ['nroPedido', 'nombreCliente', 'tipoOrden', 'estado', 'idZonaVendedor', 'nombreDistribuidor','enviadoDistribuidor', 'region', 'idProducto', 'producto', 'cantidad', 'moneda', 'total', 'totalLocal'];
  dataSource = new MatTableDataSource<PedidoDetallado>();

  filteredOptions: any;
  formControlAutocomplete = new FormControl('');
  formControlAutocompleteProducto = new FormControl('');
  hint: string = ""
  isLoading = false;
  minLengthTerm = 2;
  userName = this.loggedService.logged.userName;

  buscador: BuscadorReportePedidoDetallado;
  autocompletableZonaVendedor: boolean = true;
  selectRegiones: boolean = true;
  zonaVendedorSeleccionada: ZonaVendedor = null;
  companias: Compania[] = [];
  salesOrgs: SalesOrg[] = [];
  productoSeleccionado: Producto = null;
  alta: boolean = false;
  fDesde: Date | null;
  fHasta: Date | null
  selectTiposOrdenes: boolean = true;
  loadingReporte: boolean = false;
  botonReporte: string = "";
  estados: Estado[] = [];
  divisionSeleccionada: Division = null
  regionSeleccionada: Region = null
  estadoSeleccionado: Estado = null;
  tipoOrdenSeleccionada: ItemParametro = null;

  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private productosService: ProductosService,
    private snackBarService: SnackbarService,
    private parametrosService: ParametrosService,
    private ReportesService: ReportesService,
    private admService: AdmService,
    private excelService: ExcelService,
    private tablasService: TablasService) {


  }


  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string,
    CambiarEstado: string,
    LimpiarVendedor: string
    LimpiarProducto: string
  }


  public Etiquetas: {

    Acciones: string
    Buscar: string
    Compania: string
    Estado: string
    FechaCreacion: string
    FechaDesde: string
    FechaEstado: string,
    FechaHasta: string
    IdZonaVendedor: string
    MotivoRetencion: string
    NombreCliente: string,
    NombreDistribuidor: string;
    EnviadoDistribuidor: string;
    NroCliente: string
    NroOrdenSAP: string
    NroPedido: string;
    Path: string
    SalesOrg: string
    SinRegistros: string
    TerminoPago: string,
    Titulo: string
    Total: string,
    TotalLocal: string
    TipoOrden: string
    FilterEstado: string
    FilterProducto: string
    Region: string
    IdProducto: string
    Producto: string
    Cantidad: string
    Moneda: string
    BuscarVendedor: string,

  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.matPaginator;
    this.dataSource.sort = this.matSort;
    this.dataSource.sort.disableClear = true;
  }

  ngOnInit() {
    const buscadorData = sessionStorage.getItem('buscadorReporteDetallado');
    if (buscadorData) {
      // Recuperar el objeto y mapear las fechas a tipo Date
      const buscador: BuscadorReportePedidoDetallado = Object.assign(new BuscadorReportePedidoDetallado(), JSON.parse(buscadorData));

      // Convertir campos de fecha
      buscador.fDesde = new Date(buscador.fDesde);
      buscador.fHasta = new Date(buscador.fHasta);

      this.buscador = buscador;
      if (this.buscador.idZonaVendedor != '-1') {
        this.zonaVendedorSeleccionada = new ZonaVendedor();
        this.zonaVendedorSeleccionada.displayValue = this.buscador.idZonaVendedor + ' - ' + this.buscador.zonaVendedor
      }
      if (this.buscador.idProducto != '-1') {
        this.productoSeleccionado = new Producto();
        this.productoSeleccionado.displayValue = this.buscador.idProducto + ' - ' + this.buscador.producto
      }

      this.buscador.nroPedido = Number(buscador.nroPedido)

      if (this.buscador.idTipoOrden != "-1") {
        this.tipoOrdenSeleccionada = new ItemParametro()
        this.tipoOrdenSeleccionada.idItem = this.buscador.idTipoOrden;
      }
      if (this.buscador.idDivision != "-1") {
        this.divisionSeleccionada = new Division()
        this.divisionSeleccionada.id = this.buscador.idDivision;
      }
      if (this.buscador.idRegion != "-1") {
        this.regionSeleccionada = new Region()
        this.regionSeleccionada.id = this.buscador.idRegion;
      }

        this.buscador.idEstado = buscador.idEstado
        this.estadoSeleccionado = new Estado()
        this.estadoSeleccionado.id = buscador.idEstado.toString()
        this.estadoSeleccionado.descripcion = buscador.estado

      
    }else {
      this.buscador = new BuscadorReportePedidoDetallado();
    }
    this.botonReporte = this.configService.etiquetas.ExportarExcel;
    this.loadingReporte = false;
    this.dataSource.data = [];

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
      LimpiarVendedor: this.configService.tooltips.LimpiarVendedor,
      LimpiarProducto: this.configService.tooltips.LimpiarProducto,
      CambiarEstado: this.configService.tooltips.CambiarEstado,
      Ver: this.configService.tooltips.Ver
    }

    this.Etiquetas = {

      Acciones: this.configService.etiquetas.Acciones,
      Buscar: this.configService.etiquetas.Buscar,
      Compania: this.configService.etiquetas.Compania,
      Estado: this.configService.etiquetas.Estado,
      FechaCreacion: this.configService.etiquetas.FechaCreacion,
      FechaDesde: this.configService.etiquetas.FechaDesde,
      FechaEstado: this.configService.etiquetas.FechaEstado,
      FechaHasta: this.configService.etiquetas.FechaHasta,
      IdZonaVendedor: this.configService.etiquetas.IdZonaVendedor,
      MotivoRetencion: this.configService.etiquetas.MotivoRetencion,
      NombreCliente: this.configService.etiquetas.NombreCliente,
      NombreDistribuidor: this.configService.etiquetas.NombreDistribuidor,
      EnviadoDistribuidor: this.configService.etiquetas.EnviadoDistribuidor,
      NroCliente: this.configService.etiquetas.NroCliente,
      NroOrdenSAP: this.configService.etiquetas.NroOrdenSAP,
      NroPedido: this.configService.etiquetas.NroPedido,
      Path: this.configService.etiquetas.ReportesPedidosDetallados.Buscador.Path,
      SalesOrg: this.configService.etiquetas.SalesOrg,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      TerminoPago: this.configService.etiquetas.TerminoPago,
      Titulo: this.configService.etiquetas.ReportesPedidosDetallados.Buscador.Titulo,
      Total: this.configService.etiquetas.Total,
      TotalLocal: this.configService.etiquetas.TotalLocal,
      TipoOrden: this.configService.etiquetas.TipoOrden,
      FilterEstado: this.configService.etiquetas.FilterEstado,
      FilterProducto: this.configService.etiquetas.FilterProducto,
      Region: this.configService.etiquetas.Region,
      IdProducto: this.configService.etiquetas.IdProducto,
      Producto: this.configService.etiquetas.Producto,
      Cantidad: this.configService.etiquetas.Cantidad,
      Moneda: this.configService.etiquetas.Moneda,
      BuscarVendedor: this.configService.etiquetas.BuscarVendedor,

    }
    // this.buscador = new BuscadorReportePedidoDetallado();
    this.formControlAutocomplete = new FormControl();
    this.formControlAutocomplete.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTerm
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.filteredOptions = [];
          this.isLoading = true;
        }),
        switchMap(value => this.admService.cZonasVendedoresAutocompleteSearch(this.loggedService.logged.idPais, this.buscador.idCompania, this.buscador.idSalesOrg, value)
          .pipe(
            finalize(() => {
              this.isLoading = false
            }),
          )
        )
      )
      .subscribe((data: ZonaVendedor[]) => {
        this.filteredOptions = data;

      });

    this.formControlAutocompleteProducto = new FormControl();
    this.formControlAutocompleteProducto.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTerm
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.filteredOptions = [];
          this.isLoading = true;
        }),
        switchMap(value => this.productosService.cProductosAutocompleteSearch(this.loggedService.logged.idPais, this.buscador.idCompania, this.buscador.idSalesOrg, value)
          .pipe(
            finalize(() => {
              this.isLoading = false
            }),
          )
        )
      )
      .subscribe((data: Producto[]) => {
        this.filteredOptions = data;

      });
    this.buscador.idPais = this.loggedService.logged.idPais;
    if (this.buscador.fDesde == null) {
    this.buscador.fHasta = new Date();
    const fechaDesdeDate = new Date();
    fechaDesdeDate.setMonth(fechaDesdeDate.getMonth() - 4);
    this.buscador.fDesde = fechaDesdeDate;
    }
    forkJoin([
      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.admService.cEstados(this.loggedService.logged.idPais)


    ]).subscribe((data: [Compania[], SalesOrg[], Estado[]]) => {

      if (data[0].length) {

        this.companias = data[0];
        this.buscador.idCompania = data[0][0].id;
      }

      if (data[1].length) {

        this.salesOrgs = data[1];
        this.buscador.idSalesOrg = data[1][0].id;
      }


      if (data[2].length) {

        this.estados = data[2];

      }
  

      this.selectorTiposOrdenes.cTiposOrdenes();
      if (!this.loggedService.logged.idRegion.length) {
        this.selectorRegion.cRegiones(this.loggedService.logged.idPais);
        this.selectRegiones = true;
      }
      else {
        this.buscador.idRegion = this.loggedService.logged.idRegion;
        this.selectRegiones = false;
      }
      if (!this.loggedService.logged.idZonaVendedor.length) {
        if (this.isInRole('VENDEDOR')) {
          this.buscador.idZonaVendedor = null;
          this.buscador.zonaVendedor = null;
          this.autocompletableZonaVendedor = false;
        }
        else {
          this.autocompletableZonaVendedor = true;
        }
      }
      else {
        this.buscador.idZonaVendedor = this.loggedService.logged.idZonaVendedor;
        this.buscador.zonaVendedor = this.loggedService.logged.zonaVendedor;
        this.autocompletableZonaVendedor = false;
      }
      if (this.loggedService.logged.nroClienteDistribuidor != null && this.loggedService.logged.nroClienteDistribuidor !== '') {
        this.buscador.nroClienteDistribuidor = this.loggedService.logged.nroClienteDistribuidor; // solo los distribuidores vienen con nroClienteDistribuidor

      } else {
        this.buscador.nroClienteDistribuidor = '-1'
      }
      let timer = setTimeout(() => {
        this.buscar(0);
      }, 250);


    });
  }

  buscar(idTipoMensaje: number) {
    sessionStorage.setItem('buscadorReporteDetallado', JSON.stringify(this.buscador));
    if (!this.buscador.nroPedido) {
      this.buscador.nroPedido = 0;
    }
    this.buscador.fDesde.setHours(0, 0, 0);
    this.buscador.fHasta.setHours(0, 0, 0);
    this.ReportesService
      .cPedidosDetallados(this.buscador)
      .subscribe((data: PedidoDetallado[]) => {
        this.dataSource.data = [];
        if (data.length) {
          
          this.dataSource.data = data;

        }

      })

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  recibirTipoOrdenEmitida
    (tipoOrden: any) {
    if (typeof tipoOrden != 'undefined') {
      this.tipoOrdenSeleccionada = tipoOrden;
      if (tipoOrden != this.buscador.idTipoOrden) {
        this.buscador.idTipoOrden = tipoOrden.toString();
      }
    }
  }

  recibirDivisionEmitida(division: any) {
    if (typeof division != 'undefined') {
      this.divisionSeleccionada = division;
      if (division != this.buscador.idDivision) {
        this.buscador.idDivision = division.toString();
      }
    }
  }

  recibirRegionEmitida(region: any) {
    if (typeof region != 'undefined') {
      this.regionSeleccionada = region;
      if (region != this.buscador.idRegion) {
        this.buscador.idRegion = region.toString();
      }
    }
  }


  getOptionText(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  seleccionarProducto(p: any) {
    this.productoSeleccionado = p;
    this.buscador.idProducto = this.productoSeleccionado.id;
    this.buscador.producto = this.productoSeleccionado.descripcion;
  }

  handleEmptyInputProducto(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTerm) {
      this.limpiarProducto(false);
    }
  }
  limpiarProducto(resetFormControl: boolean) {
    this.filteredOptions = [];
    this.productoSeleccionado = null;
    this.buscador.idProducto = "-1";
    if (resetFormControl) {
      this.formControlAutocompleteProducto.setValue('');

    }

  }

  seleccionarVendedor(zv: any) {
    this.zonaVendedorSeleccionada = zv;
    this.buscador.idZonaVendedor = this.zonaVendedorSeleccionada.id;
    this.buscador.zonaVendedor = this.zonaVendedorSeleccionada.descripcion;
  }

  handleEmptyInputVendedor(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTerm) {
      this.limpiarVendedor(false);
    }
  }
  limpiarVendedor(resetFormControl: boolean) {
    this.filteredOptions = [];
    this.zonaVendedorSeleccionada = null;
    this.buscador.idZonaVendedor = "-1";
    if (resetFormControl) {
      this.formControlAutocomplete.setValue('');

    }

  }

  clasePorEstado(idEstado: string, idTipoOrden: string) {
    let clase = ClasePorEstado(idTipoOrden, idEstado);
    return clase;
  }


  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
  cReporteExcel() {
    this.loadingReporte = true;
    this.botonReporte = this.configService.etiquetas.Descargando;
    let timer = setTimeout(() => {
      this.loadingReporte = false;
      this.botonReporte = this.configService.etiquetas.ExportarExcel;
    }, 120000);

        if (this.dataSource != null) {
          this.excelService.cExcelReportePedidosDetallados(this.dataSource.filteredData);
          this.loadingReporte = false;
          this.botonReporte = this.configService.etiquetas.ExportarExcel;
        }


  }

  selectEstado(e: any) {

    if (e != null) {
      this.buscador.estado = e.descripcion;
      this.buscador.idEstado = e.id;

    }

  }

  compareEstados(eLista: any, e: any): boolean {
    return eLista.descripcion == e.descripcion;
  }
}


